import { NEW_LANDINGI_URL } from '@config/env'
import { CREDIT_CARD, PAYPAL } from '@constants/paymentMethods'
import { useUserContext } from '@contexts/user'
import StatusIconSuccess from '@images/checkout/status-icon-success.svg'
import styles from '@pages/Checkout/routes/Confirmation/Confirmation.module.scss'
import { INVOICES } from '@routes/path'
import { Button, Heading, Image, Panel, Paragraph, Spreader } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import { getPaymentInfoContent } from './helpers/getPaymentInfoContent'

export const PaymentInfoPanel = () => {
  const { t } = useTranslation()

  const { userEmail, expiresAt, paymentMethod, nextBillingDateFormatted } =
    useUserContext()

  const hasUserPaidByCreditCardOrPaypal =
    (paymentMethod === CREDIT_CARD || paymentMethod === PAYPAL) &&
    Boolean(nextBillingDateFormatted)

  const handleGoToInvoices = () => {
    window.open(`https://${NEW_LANDINGI_URL}${INVOICES.INVOICES}`, '_self')
  }

  const { heading, description } = getPaymentInfoContent({
    hasUserPaidByCreditCardOrPaypal,
    nextBillingDateFormatted,
    userEmail,
    expiresAt
  })

  return (
    <Panel
      surface={0}
      border='neutral-2'
      padding={30}
      className={styles['confirmation__payment-info-panel']}
      data-testid='payment-info-panel'
    >
      <Column
        justifyContent='space-between'
        className={styles['confirmation__payment-info-panel__content']}
      >
        <Row alignItems='center'>
          <Image src={StatusIconSuccess} width='20px' height='20px' />

          <Spreader spread={10} />

          <Heading
            level={3}
            weight={600}
            data-testid='payment-info-panel-heading'
          >
            {heading}
          </Heading>
        </Row>

        <Paragraph data-testid='payment-info-panel-description'>
          {description}
        </Paragraph>

        <Row justifyContent='flex-end'>
          <Button
            variant='outlined'
            onClick={handleGoToInvoices}
            data-testid='invoices-button'
          >
            {t('checkout.confirmation.payment.info.button.invoices')}
          </Button>
        </Row>
      </Column>
    </Panel>
  )
}
